import { FormFieldComponentProps } from "../components/new_form/form_fields/FormFieldComponent";
import { NewMultipleSelectionQueryDropdownFieldComponentProps } from "../components/new_form/form_fields/NewMultipleSelectionQueryDropdownFieldComponent";
import { NewMultipleFormComponentProps } from "../components/new_form/NewMultipleFormComponentProps";
import { getSession } from "../helper";
import {
  LIST_ELEMENTS_FOR_DROPDOWNS,
  LIST_PHYSICAL_LIBRARY_LOCATIONS,
} from "../routes/queries";

export function getReferenceLibraryForm(): NewMultipleFormComponentProps {
  return {
    type: "multiple_form",
    formFields: getReferenceLibraryFormFields(),
    typeSelector: {
      type: "hardcoded_dropdown",
      key: "type",
      label: "Type",
      required: true,
      options: [
        { key: 1, value: 1, text: "Document" },
        { key: 2, value: 2, text: "Link" },
        { key: 3, value: 3, text: "Physical Item" },
      ],
    },
  };
}

export function getReferenceLibraryFormFields(): FormFieldComponentProps[][] {
  return [
    [
      {
        type: "text",
        key: "name",
        label: "Name",
        required: true,
        placeholder: "Reference Library Element Name",
      },
      {
        type: "text",
        key: "body",
        label: "Body",
        required: false,
        placeholder: "Body",
      },
      {
        type: "multiple_selection_query_dropdown",
        key: "elementIds",
        label: "Related Elements",
        required: false,
        apiCall: LIST_ELEMENTS_FOR_DROPDOWNS,
        apiVariables: {
          session: getSession(),
          types: [1, 2, 3, 4, 5],
        },
        itemName: "Element",
      },
    ],
    [
      {
        type: "text",
        key: "name",
        label: "Name",
        required: true,
        placeholder: "Reference Library Element Name",
      },
      {
        type: "text",
        key: "body",
        label: "Link",
        placeholder: "Enter link",
        required: true,
      },
      {
        type: "multiple_selection_query_dropdown",
        key: "elementIds",
        label: "Related Elements",
        required: false,
        apiCall: LIST_ELEMENTS_FOR_DROPDOWNS,
        apiVariables: {
          session: getSession(),
          types: [1, 2, 3, 4, 5],
        },
        itemName: "Element",
      },
    ],
    [
      {
        type: "text",
        key: "name",
        label: "Name",
        required: true,
        placeholder: "Reference Library Element Name",
      },
      {
        type: "query_dropdown",
        key: "physicalLibraryLocationId",
        label: "Physical Library Location",
        required: true,
        noSelectionLabel: "No Physical Library Location",
        apiCall: {
          documentNode: LIST_PHYSICAL_LIBRARY_LOCATIONS,
          key: "listPhysicalLibraryLocations",
        },
        apiVariables: {
          session: getSession(),
        },
      },
      {
        type: "multiple_selection_query_dropdown",
        key: "elementIds",
        label: "Related Elements",
        required: false,
        apiCall: LIST_ELEMENTS_FOR_DROPDOWNS,
        apiVariables: {
          session: getSession(),
          types: [1, 2, 3, 4, 5],
        },
        itemName: "Element",
      },
    ],
  ];
}
